import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `EmpresaCentro/generarExcel`, method: 'POST', body: null, token: token})
}